export default "__VITE_ASSET__BjK9Omwa__"